import React from 'react';
import type { CardBlock as CardBlockType } from '../../../types';
import BlockRenderer from '../BlockRenderer';

type Props = {
    block: CardBlockType;
    depth: number;
};

const CardBlock: React.FC<Props> = ({ block, depth }) => (
    <div
        style={{
            margin: '0.8rem 0',
            padding: '1.2rem',
            borderRadius: '0.8rem',
            border: block.style === 'flat' ? '1px solid #e0e0e0' : 'none',
            boxShadow: block.style !== 'flat' ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
            backgroundColor: '#fff'
        }}
    >
        <BlockRenderer blocks={block.children} depth={depth + 1} />
    </div>
);
export default CardBlock;
